import {useQuery} from 'react-query';
import {UserLayersApi, UserLayerFilterVO} from '../api';
import {LayerId} from '@mc/react-mapio';
import {useMapioContext} from '../mapioContext';

export type FeatureIds = {
    totalElements: number;
    ids: string[];
};

export const CACHE_FEATURES_IDS = 'CACHE_FEATURES_IDS';

export const useFeatureIds = (layerId: LayerId, filters: UserLayerFilterVO) => {
    const mapioContext = useMapioContext();
    return useQuery<FeatureIds>(
        [CACHE_FEATURES_IDS, layerId, filters],
        async () => {
            const result = (await UserLayersApi.getFeatureIds(Number(layerId), mapioContext.value?.context, filters)).data;

            return {
                totalElements: result.length,
                ids: result,
            };
        },
        {
            enabled: !!layerId,
            refetchOnWindowFocus: true,
            refetchOnReconnect: false,
            refetchOnMount: false,
        },
    );
};
